import React from "react";

import ToolLayout from "../ToolLayout";
import InspirationExplorerTool from "./InspirationExplorerTool";
import InspirationExplorerConfig from "./InspirationExplorer.config";

/**
 * InspirationExplorerPage
 *
 * Standalone, SEO-indexable page wrapper for the Inspiration Explorer tool.
 */
const InspirationExplorerPage = () => {
  return (
    <ToolLayout
      title={InspirationExplorerConfig.title}
      description={InspirationExplorerConfig.description}
    >
      <InspirationExplorerTool />
    </ToolLayout>
  );
};

export default InspirationExplorerPage;
